




























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Issue } from '@/interfaces/Issue';
import { Cutoverplan } from '@/interfaces/Cutoverplan';
import { Environment } from '@/interfaces/Environment';

@Component({})
export default class IssueRowCard extends Vue {
  @Prop()
  cutoverplan!: Cutoverplan;

  @Prop()
  issue!: Issue;

  datemenu = false;

  statuses = [
    {
      value: 'OPEN',
      text: 'OFFEN'
    },
    {
      value: 'IN_PROGRESS',
      text: 'IN ARBEIT'
    },

    {
      value: 'CLOSED',
      text: 'GESCHLOSSEN'
    }
  ];

  get backgroundColor() {
    const environment = this.$store.state.all_environments.find(
      (e: Environment) => e.id === this.issue.environment_id
    );
    if (environment) return environment.color;
    return '#FFFFFF';
  }

  get environments() {
    return [
      {
        value: null,
        text: 'ALLE'
      },
      ...this.$store.state.all_environments.map((environment: any) => ({
        value: environment.id,
        text: environment.name
      }))
    ];
  }
}
